import { render, staticRenderFns } from "./BusinessAdvantageCard.vue?vue&type=template&id=e06fc3f4&scoped=true"
import script from "./BusinessAdvantageCard.vue?vue&type=script&lang=js"
export * from "./BusinessAdvantageCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessAdvantageCard.vue?vue&type=style&index=0&id=e06fc3f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06fc3f4",
  null
  
)

export default component.exports